import classNames from "classnames";
import { ErrorMessage, type ErrorMessageProps } from "formik";
import { inject } from "mobx-react";
import { type FunctionComponent } from "react";
import { FormattedMessage } from "react-intl";
import { compose } from "nvent-web/utils/compose";

import { type Message } from "nvent-web/i18n/yup";
import AppStore from "nvent-web/stores/App";

import style from "./FieldError.module.scss";

export interface FieldErrorProps extends Omit<
  ErrorMessageProps,
  "className" | "component"
> {
  name: string;
  className?: {
    container?: string;
    message?: string;
  };
}

export const FieldError: FunctionComponent<FieldErrorProps> = ({
  className = {},
  name,
}) => (
  <div className={classNames(className.container, style.container)}>
    <p className={classNames(className.message, style.message)}>
      <ErrorMessage component={FormattedErrorMessage} name={name} />
    </p>
  </div>
);

export interface FormattedErrorMessageInnerProps {
  app: AppStore;
  children: React.ReactNode;
}

export const FormattedErrorMessageInner: FunctionComponent<
  FormattedErrorMessageInnerProps
> = ({ children }) => {
  if (typeof children === "string") {
    return <>{children}</>;
  }

  return <FormattedMessage {...(children as Message)} />;
};

export const FormattedErrorMessage = compose(inject("app"))(
  FormattedErrorMessageInner
);
